import React, { Component } from "react";
import { withRouter } from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as CONFIG from "./_config";
import ls from "local-storage";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";

const axios = require("axios");

class SimpleSlider__NOT_ABLE_TO_ZOOM_INTO extends Component {
  render() {
    function SampleNextArrow(props) {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    }

    function SamplePrevArrow(props) {
      const { className, style, onClick } = props;
      return (
        <div
          className={className}
          style={{ ...style, display: "block" }}
          onClick={onClick}
        />
      );
    }

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      adaptiveHeight: true,
      swipeToSlide: true,
      fade: false,
      appendDots: (dots) => (
        <div>
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
      ),
      customPaging: (i) => (
        <div
          style={{
            display: "inline-block",
            border: "3px solid",
            color: CONFIG.DATA.LOGO_COLOR || "#95a83f",
            fontFamily: "roboto",
            fontSize: "11pt",
            fontWeight: "bold",
            paddingTop: "5px",
            marginRight: 7,
            width: 40,
            height: 40,
            borderRadius: "50% 50%",
            textAlign: "center",
            textDecoration: "none",
          }}
        >
          {i + 1}
        </div>
      ),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {},
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    /*
        return (
            <Slider {...settings}>
                {this.props.sliders.map((value, index) => (
                    <div key={index}>
                        <TransformWrapper>
                            <TransformComponent>
                                <a href={value.URL} >
                                <img 
                                    style={{}} 
                                    src={value.URL} 
                                    alt="Weekly Ad" 
                                    className="weekly-ad-img" 
                                />
                                </a> 
                                </TransformComponent>
                            </TransformWrapper>
                    </div>
                ))}

            </Slider>
        );
        */
    const [sliderRef, slider] = useKeenSlider();
    return (
      <div ref={sliderRef}>
        {this.props.sliders.map((value, index) => (
          <div class="keen-slider__slide" key={index}>
            <img
              style={{}}
              src={value.URL}
              alt="Weekly Ad"
              className="weekly-ad-img"
            />
          </div>
        ))}
      </div>
    );
  }
}

export function SimpleSlider(props) {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  return (
    <>
      {/* 
        https://codesandbox.io/s/github/rcbyr/keen-slider-sandboxes/tree/master/navigation/arrows-and-dots/react?file=/src/styles.css
        */}
      {slider && (
        <div className="dots">
          {[...Array(slider.details().size).keys()].map((idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  slider.moveToSlideRelative(idx);
                }}
                className={"dot" + (currentSlide === idx ? " active" : "")}
              >
                {idx + 1}
              </button>
            );
          })}
        </div>
      )}
      <div ref={sliderRef} className="keen-slider">
        {props.sliders.map((value, index) => (
          <div className="keen-slider__slide" key={index}>
            <TransformWrapper>
              <TransformComponent>
                <img
                  style={{}}
                  src={value.URL}
                  alt="Weekly Ad"
                  className="weekly-ad-img1"
                />
              </TransformComponent>
            </TransformWrapper>
          </div>
        ))}
        {slider && (
          <>
            <ArrowLeft
              onClick={(e) => e.stopPropagation() || slider.prev()}
              disabled={currentSlide === 0}
            />
            <ArrowRight
              onClick={(e) => e.stopPropagation() || slider.next()}
              disabled={currentSlide === slider.details().size - 1}
            />
          </>
        )}
      </div>
      {slider && (
        <div className="dots">
          {[...Array(slider.details().size).keys()].map((idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  slider.moveToSlideRelative(idx);
                }}
                className={"dot" + (currentSlide === idx ? " active" : "")}
              >
                {idx + 1}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}

function ArrowLeft(props) {
  const disabeld = props.disabled ? " arrow--disabled" : "";
  return (
    <svg
      onClick={props.onClick}
      className={"arrow arrow--left" + disabeld}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
    </svg>
  );
}

function ArrowRight(props) {
  const disabeld = props.disabled ? " arrow--disabled" : "";
  return (
    <svg
      onClick={props.onClick}
      className={"arrow arrow--right" + disabeld}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </svg>
  );
}
class WeeklyAd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      WeeklyAds: null,
      PDFURL: null,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log('this',this.props);
    // console.log('prevProps',prevProps);
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // console.log('route changes1');
      this.WeeklyAds();
      ls.set("redirectTo", window.location.href);
    }
  }

  componentDidMount() {
    // console.log('route changes2');
    this.WeeklyAds();

    ls.set("redirectTo", window.location.href);
  }

  WeeklyAds = () => {
    // this.setState({WeeklyAds: []});

    let StoreID = this.props.match.params.id;
    let store_name = this.props.match.params.store;
    let store = null;
    if (StoreID !== "") {
      this.setState({ store: store });
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN;
    var ClientStoreId = StoreID !== null && StoreID > 0 ? StoreID : 1;

    // console.log('route changes3');

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/WeeklyAdGallery/${UserToken}/${ClientStoreId}`;

    axios
      .get(apiurl, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        setTimeout(() => {
          if (res.data.GalleryItems && res.data.GalleryItems != null) {
            this.setState({
              WeeklyAds: res.data.GalleryItems,
              PDFURL: res.data.PDFURL,
            });
          } else {
            this.setState({ WeeklyAds: [], PDFURL: null });
          }
        }, 10);
      })
      .catch(function (response) {
        console.log(response);
      });
  };

  render() {
    const WeeklyAds = this.state.WeeklyAds;
    const PDFURL = this.state.PDFURL;
    const name = this.props.match.params.store_name || "";

    return (
      <div>
        <div className="main-container default-page pt-2 mt-2 mb-5  ">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Weekly Ads</h2>
                      <ol className="breadcrumb ml-5">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/weekly-ads">Weekly Ads</a>
                        </li>
                        <li>
                          <span
                            className="active"
                            dangerouslySetInnerHTML={{
                              __html:
                                "Weekly Ad " +
                                name
                                  .replace("---", "-")
                                  .replace(/-/g, "&nbsp;"),
                            }}
                          ></span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1
                    className="entry-title"
                    style={{ textTransform: "capitalize" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        "Weekly Ad " +
                        name.replace("---", "-").replace(/-/g, "&nbsp;"),
                    }}
                  ></h1>
                </header>
                <div className="breadcrumbs d-none d-md-block">
                  <a href="/">Home</a>
                  <span className="separator">/</span>
                  <a href="/weekly-ads" title="Weekly Ads">
                    Weekly Ads
                  </a>
                  <span className="separator">/</span>
                  <span
                    title="Weekly Ad"
                    style={{ textTransform: "capitalize" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        "Weekly Ad " +
                        name.replace("---", "-").replace(/-/g, "&nbsp;"),
                    }}
                  ></span>
                </div>
              </div>
            </div>
          )}

          <div className="clearfix"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {PDFURL && PDFURL.length > 0 && (
                  <a
                    className="a_view_all_pdf_top"
                    target="_blank"
                    href={PDFURL}
                  >
                    View Full PDF
                  </a>
                )}
                <figure className="thumnail weekly" style={{ minHeight: 500 }}>
                  {WeeklyAds && WeeklyAds.length > 0 ? (
                    <SimpleSlider sliders={WeeklyAds} name={name} />
                  ) : WeeklyAds && WeeklyAds.length == 0 ? (
                    <div className="content">
                      <div className="overlay">
                        <div className="overlay-content">
                          <div style={{ height: "200px" }}></div>
                          <h3>No Weekly Ads found</h3>
                          <div style={{ height: "100px" }}></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="content">
                      <div className="overlay">
                        <div className="overlay-content">
                          <div style={{ height: "100px" }}></div>
                          <img
                            style={{ maxWidth: "none" }}
                            src="/assets/images/loading.gif"
                            alt="Loading..."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </figure>

                {PDFURL && PDFURL.length > 0 && (
                  <a
                    className="a_view_all_pdf_bottom"
                    target="_blank"
                    href={PDFURL}
                  >
                    View Full PDF
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const WeeklyadsPage = withRouter(WeeklyAd);
export default WeeklyadsPage;
